import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchTypeaheadLeasingContractsForFilter } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LeasingContractMultiTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadLeasingContractsForFilter: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        value: PropTypes.array,
        onChangeSuggestion: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired
    };

    static defaultProps = {
        suggestions: [],
        value: []
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadLeasingContractsForFilter(
            LeasingContractMultiTypeahead.name,
            { term }
        );
    };

    render() {
        const { suggestions, value, onChangeSuggestion, clearTypeahed, t } = this.props;
        const options = (Array.isArray(suggestions) ? suggestions : []).map(contract => ({
            label: contract.leasingContractId,
            value: contract.leasingContractId
        }));

        return (
            <MultiTypeahead
                animatedPlaceholder
                options={options}
                isMulti
                value={value}
                titleId="leasingContractId"
                selectFilterOption={() => true}
                handleSuggestionsClearRequested={clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={onChangeSuggestion}
                formatOptionLabel={renderMultiSuggestion}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions: typeahead.source === LeasingContractMultiTypeahead.name ? typeahead.list : []
});

export default connect(mapStateToProps, {
    fetchTypeaheadLeasingContractsForFilter,
    clearTypeahed
})(LeasingContractMultiTypeahead);